import React from "react"
import infoEmail from "../../../images/info-email.png"
import Button from "../../../components/button"
import './styles.css';
const AiForWorkflowAndProductivity = () => {
  const styles = {
    heading: {
      marginBottom: "10px",
      marginTop: "30px",
    },
    button: {
      cursor: "pointer",
      color: "white",
      textAlign: "center",
      fontWeight: 700,
      backgroundColor: "#092c4c",
      fontSize: "18px",
      padding: "15px 35px",
      borderRadius: "30px",
      display: "block",
      marginTop: "20px",
    },
    divsmall: {
      marginBottom: "15px",
    },
    div: {
      marginBottom: "35px",
    },
  }

  return (
    <div>
       <h6 style={styles.heading}>Classification</h6>
      <div style={styles.div}>
      {"Management and Commerce>Business and Management>Personal Management Training"}
      </div>
      <h6 style={styles.heading}>Purpose Statement</h6>
      <div style={styles.div}>The purpose of this micro-credential is to:
        <ol>
          <li>Enable learners in small-to-medium enterprises and schools to apply artificial intelligence tools to improve productivity and support personal wellbeing.</li>
          <li>Provide a sector-agnostic pathway, allowing learners from a wide range of industries to contextualise tasks in their own environment.</li>
          <li>Respond to urgent workforce needs for time-saving digital tools, reduced administrative burden, and enhanced wellbeing.</li>
        </ol>
      </div>
      <h6 style={styles.heading}>Outcome Statement</h6>
      <div style={styles.div}>On successful completion of this micro-credential, learners/ākonga will be able to:
      <ol>
      <li>Identify workflow "pressure points" that create stress or reduce efficiency.</li>
      <li>Apply safe and ethical AI practices in their work context.</li>
      <li>Build and demonstrate a simple AI helper (prompt pack, workflow template, or Gem/Custom GPT).</li>
      <li>Reflect on outcomes using Te Whare Tapa Whā, linking productivity improvements to hauora.</li>
      </ol>  
      </div>
      <h6 style={styles.heading}>Content</h6>
      <div style={styles.div}>
        <p>Component 1: Identify & Map a Workflow Pressure Point </p>
        <ol>
          <li>Understanding "pressure points" in SME and education workflows </li>
          <li>Mapping processes (simple task-flow diagrams, pain-point analysis) </li>
          <li>Linking workflow pressure to productivity and wellbeing </li>
        </ol>
        <p>Component 2: Apply Safe AI Practices </p>
        <ol>
          <li>Safe and ethical use of AI (privacy, bias, data protection, disclosure)</li>
          <li>Organisational boundaries and approvals</li>
          <li>Sector-agnostic safe-use checklists</li>
        </ol>
        <p>Component 3: Build & Demonstrate a Simple AI Helper </p>
        <ol>
          <li>Introduction to prompt engineering</li>
          <li>Using workflow templates</li>
          <li>Configuring a templated Gem/Custom GPT</li>
          <li>Preparing a simple demo (video, live, or screenshot evidence)</li>
        </ol>
        <p>Component 4: Reflect on Productivity & Wellbeing (Te Whare Tapa Whā) </p>
        <ol>
          <li>Introduction to Te Whare Tapa Whā as a wellbeing framework</li>
          <li>Connecting productivity and hauora outcomes</li>
          <li>Planning next steps for AI use in workflow practice</li>
        </ol>
      </div>
      <h6 style={styles.heading}>Admission</h6>
      <div style={styles.div}>
      <p>There are no formal academic prerequisites for this micro-credential.</p>
      <br></br>
      <p>Entry requirements:</p>
        <ol>
          <li>Learners must be engaged in a workplace, education, or community context where workflow tasks are carried out.</li>
          <li>Learners should have basic digital literacy (e.g., ability to use email, web applications, and word processing).</li>
          <li>Learners will need access to a computer or device with internet connectivity.</li>
          <li>Learners should have sufficient English language and communication skills to participate in workshops, complete reflection tasks, and demonstrate learning outcomes.</li>
          <li>No prior experience with AI tools is required.</li>
        </ol>
        <p>This ensures the micro-credential is accessible to a broad range of learners across SMEs, education, and community sectors, while maintaining the digital baseline necessary to complete tasks.
</p>
      </div>
      <h6 style={styles.heading}>Education Pathway</h6>
      <div style={styles.div}>
      <p>This micro-credential builds upon:</p>
        <ol>
          <li>General workplace digital literacy and entry-level use of productivity tools.</li>
          <li>Informal experience with AI tools such as ChatGPT or Gemini.</li>
        </ol>
        <p>This micro-credential may lead to:</p>
        <ol>
          <li>Further micro-credentials in digital productivity and applied AI.</li>
          <li>Short courses or programmes in workplace technology, business management, or digital literacy.</li>
          <li>Other professional development opportunities focused on workflow design, project management, or wellbeing at work.</li>
        </ol>
      </div>
      <h6 style={styles.heading}>Employment Pathway</h6>
        <p>On successful completion of this micro-credential, learners/ākonga will be able to carry out the following in their workplace:</p>
        <ol>
          <li>Apply AI safely and effectively in their daily roles across SMEs, education, healthcare, and trades.</li>
          <li>Reduce administrative burden and free up time for customer-facing, whānau-facing, or learner-facing work.</li>
          <li>Strengthen hauora by integrating productivity gains with Te Whare Tapa Whā wellbeing reflection.</li>
        </ol>
      <h6 style={styles.heading}>Education Organisations that can deliver this Micro-credential</h6>
        <p>6659 Summit Institute Limited</p>
     <h6 style={styles.heading}>Length/duration</h6>
     <div style={styles.divsmall}>
      <strong style={styles.heading}>Total (weeks)</strong>
      <p>12 Including holiday weeks</p></div>
      <div style={styles.divsmall}>
      <strong style={styles.heading}>Training/Teaching (weeks)</strong>
      <p>10 Excluding holiday weeks</p></div>
      <div style={styles.divsmall}>
      <strong style={styles.heading}>Total learning hours (per week)</strong>
      <p>5.00</p>
     </div>
      <div className="contact-content" style={{width:"100%",background:"#083051",paddingTop:"30px",paddingBottom:"30px"}}>
              <h3 className="contact-heading">We'd love to hear from you</h3>
              <span style={{ marginBottom: "10px" }}>
                You can contact us at
              </span>
              <img
                src={infoEmail}
                style={{ marginBottom: "20px"}}
                alt="email address" className="responsive-img"
              />
              <span style={{ marginBottom: "20px" }}>
                and one of our team will be in touch
              </span>
              <a href="mailto:contact@summitinstitute.ac.nz?subject=Mail from Summit Institute">
                <Button colorSchema="sec">Email us</Button>
              </a>
            </div>
    </div>
  )
}

export default AiForWorkflowAndProductivity
